(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0fc8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0fc8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jOfgJ", function(module, exports) {

var $awuvz = parcelRequire("awuvz");

var $6yaUa = parcelRequire("6yaUa");
parcelRequire("fa6hB");
var $ZjXzN = parcelRequire("ZjXzN");
/**
 * Handle the click event on the "show password" buttons
 */ const $0ec2684f53c0aee2$var$showPasswordButtons = Array.from(document.querySelectorAll('[data-action="show-password"]'));
$0ec2684f53c0aee2$var$showPasswordButtons.forEach((button)=>{
    button.addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopImmediatePropagation();
        const currentButton = e.currentTarget;
        const inputEl = currentButton.parentElement?.children[0];
        const isText = inputEl.type === "text";
        if (isText) {
            inputEl.type = "password";
            currentButton.setAttribute((0, $awuvz.i18n_PATH_ATTRIBUTE), "pages.common.showPassword");
            currentButton.innerText = (0, $6yaUa.t)("pages.common.showPassword");
        } else {
            inputEl.type = "text";
            currentButton.setAttribute((0, $awuvz.i18n_PATH_ATTRIBUTE), "pages.common.hidePassword");
            currentButton.innerText = (0, $6yaUa.t)("pages.common.hidePassword");
        }
    });
});
const $0ec2684f53c0aee2$var$languageSelect = document.querySelector("select.language-select");
const $0ec2684f53c0aee2$var$languageFooterContainer = document.querySelector("footer .language-select-container");
/**
 * Handle locale change
 */ if ($0ec2684f53c0aee2$var$languageSelect) $0ec2684f53c0aee2$var$addSelectLocaleChangeListener($0ec2684f53c0aee2$var$languageSelect);
/**
 * Set the initial locale & handle i18n
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const locale = (0, $6yaUa.currentLocale)();
    document.documentElement.lang = locale;
    if ($0ec2684f53c0aee2$var$languageSelect && $0ec2684f53c0aee2$var$languageSelect?.value !== locale) $0ec2684f53c0aee2$var$languageSelect.value = locale;
    (0, $6yaUa.translateHtml)();
    const queryError = new URL(window.location.href).searchParams.get((0, $awuvz.QUERY_PARAM_ERROR_KEY));
    const pageScope = document.body.getAttribute("data-scope");
    if (queryError && pageScope !== "error") (0, $ZjXzN.Notifications).create(queryError, 5000);
    if ($0ec2684f53c0aee2$var$languageFooterContainer && $0ec2684f53c0aee2$var$languageSelect) {
        const languageSelectClone = $0ec2684f53c0aee2$var$languageSelect.cloneNode(true);
        if (languageSelectClone && languageSelectClone?.value !== locale) languageSelectClone.value = locale;
        $0ec2684f53c0aee2$var$addSelectLocaleChangeListener(languageSelectClone);
        $0ec2684f53c0aee2$var$languageFooterContainer.appendChild(languageSelectClone);
    }
    document.documentElement.setAttribute("user-agent", navigator.userAgent);
    if (navigator.userAgent.indexOf("Win") !== -1) document.documentElement.setAttribute("data-os", "windows");
    Array.from(document.querySelectorAll("select")).forEach((select)=>{
        select.setAttribute("data-selected", String(!!select.value));
        select.addEventListener("change", (e)=>{
            const selectNode = e.target;
            selectNode.setAttribute("data-selected", String(!!selectNode.value));
        });
    });
});
document.addEventListener("SpartaAuthLocaleChanged", (e)=>{
    const languageSelects = document.querySelectorAll("select.language-select");
    const eventLocale = e?.detail?.locale;
    Array.from(languageSelects).forEach((select)=>{
        if (eventLocale) // We want to update all language selects to the new locale
        select.value = eventLocale;
    });
    /**
   * Update user culture in Cookiebot
   * there is no direct method to update the culture, so we need to renew the script src params
   */ if (window.CookiebotDialog.visible) {
        if (typeof window.CookieConsent !== "undefined") {
            const ucScriptElement = document.querySelector(window.CookieConsent.scriptId) || window.CookieConsent.scriptElement;
            if (ucScriptElement && ucScriptElement?.src) {
                const ucScriptUrl = new URL(ucScriptElement.src);
                ucScriptUrl.searchParams.set("culture", (0, $6yaUa.currentLocale)());
                ucScriptElement.src = ucScriptUrl.toString();
                // Refresh the cookiebot dialog
                if (!window.Cookiebot.consented && !window.Cookiebot.declined && !window.Cookiebot.isRenewal) window.Cookiebot.show();
                // Refresh the cookiebot renew dialog
                if (window.Cookiebot.isRenewal) window.Cookiebot.renew();
            }
        }
    }
});
/**
 * Custom event for locale change
 */ const $0ec2684f53c0aee2$var$SpartaAuthLocaleChangedEvent = new CustomEvent("SpartaAuthLocaleChanged");
function $0ec2684f53c0aee2$var$addSelectLocaleChangeListener(select) {
    select.addEventListener("change", (e)=>{
        const locale = e.currentTarget?.value;
        if (locale) {
            // Set the locale
            (0, $6yaUa.setLocale)(locale);
            // Translate our document
            (0, $6yaUa.translateHtml)();
            // Dispatch our custom locale change event for dependencies.
            document.dispatchEvent(new CustomEvent("SpartaAuthLocaleChanged", {
                detail: {
                    locale: locale
                }
            }));
        }
    });
}
const $0ec2684f53c0aee2$var$cookiesButton = document.querySelector("#cookiesSettingsButton");
$0ec2684f53c0aee2$var$cookiesButton?.addEventListener("click", (e)=>{
    e.preventDefault();
    if (typeof window.Cookiebot !== "undefined") {
        /**
     * Update user culture in Cookiebot
     * there is no direct method to update the culture, so we need to renew the script src params
     */ if (typeof window.CookieConsent !== "undefined") {
            const ucScriptElement = document.querySelector(window.CookieConsent.scriptId) || window.CookieConsent.scriptElement;
            if (ucScriptElement && ucScriptElement?.src) {
                const ucScriptUrl = new URL(ucScriptElement.src);
                ucScriptUrl.searchParams.set("culture", (0, $6yaUa.currentLocale)());
                ucScriptElement.src = ucScriptUrl.toString();
            }
        }
        window.Cookiebot?.renew?.();
    }
});
// window.addEventListener('CookiebotOnDialogInit', function (e) {
// });
/**
 * Mobile apps will send a custom user-agent string
 * that will be used to hide the cookie banner.
 */ window.addEventListener("CookiebotOnDialogDisplay", function(e) {
    // Hide the cookie banner for the mobile app
    if (navigator?.userAgent?.toLowerCase()?.includes("ac sparta praha")) window.Cookiebot.hide();
    else // If the user language is different from the current locale, we need to update the user culture in Cookiebot
    if (e.target?.CookieConsentDialog?.userLanguage !== (0, $6yaUa.currentLocale)()) {
        window.Cookiebot.hide?.();
        if (typeof window.CookieConsent !== "undefined") {
            const ucScriptElement = document.querySelector(window.CookieConsent.scriptId) || window.CookieConsent.scriptElement;
            if (ucScriptElement && ucScriptElement?.src) {
                const ucScriptUrl = new URL(ucScriptElement.src);
                ucScriptUrl.searchParams.set("culture", (0, $6yaUa.currentLocale)());
                ucScriptElement.src = ucScriptUrl.toString();
            }
            window.Cookiebot.show?.();
        }
    }
});

});
parcelRegister("awuvz", function(module, exports) {

$parcel$export(module.exports, "EMAIL_PREFILL_LOCAL_STORAGE_KEY", function () { return $6a1e4986bef74680$export$ca799f0c9989c62f; });
$parcel$export(module.exports, "LOCALE_COOKIE_KEY", function () { return $6a1e4986bef74680$export$2b987a6a0cc2a719; });
$parcel$export(module.exports, "i18n_PATH_ATTRIBUTE", function () { return $6a1e4986bef74680$export$de155f41b6f208bb; });
$parcel$export(module.exports, "i18n_TARGET_ATTRIBUTE", function () { return $6a1e4986bef74680$export$f317764fa0bcd8a7; });
$parcel$export(module.exports, "i18n_VALUES_ATTRIBUTE", function () { return $6a1e4986bef74680$export$2048bd9203cf859b; });
$parcel$export(module.exports, "DATA_DEFAULT_ATTRIBUTE", function () { return $6a1e4986bef74680$export$ec48e3e3ef77ad44; });
$parcel$export(module.exports, "PASSWORD_TIMEOUT_LOCALSTORAGE_KEY", function () { return $6a1e4986bef74680$export$b7fea8286a4dbf6a; });
$parcel$export(module.exports, "RETRY_TIMEOUT_SECONDS", function () { return $6a1e4986bef74680$export$e0d09a1a7b4e72ff; });
$parcel$export(module.exports, "QUERY_PARAM_LOCALE_KEY", function () { return $6a1e4986bef74680$export$dd8d693d6d107c97; });
$parcel$export(module.exports, "QUERY_PARAM_ERROR_KEY", function () { return $6a1e4986bef74680$export$31aa35d496f399b3; });
$parcel$export(module.exports, "QUERY_PARAM_USER_CODE_KEY", function () { return $6a1e4986bef74680$export$3228d6a4dffe969e; });
$parcel$export(module.exports, "DEVICE_USER_CODE_COOKIE_KEY", function () { return $6a1e4986bef74680$export$bdd4ef52fecf6cd1; });
/**
 * Localstorage key for email prefill - used in register / authorize form.
 */ const $6a1e4986bef74680$export$ca799f0c9989c62f = "spt_id_email_prefill";
const $6a1e4986bef74680$export$2b987a6a0cc2a719 = "Next-Locale";
const $6a1e4986bef74680$export$de155f41b6f208bb = "data-i18n";
const $6a1e4986bef74680$export$f317764fa0bcd8a7 = "i18n-target";
const $6a1e4986bef74680$export$2048bd9203cf859b = "i18n-values";
const $6a1e4986bef74680$export$ec48e3e3ef77ad44 = "data-default";
const $6a1e4986bef74680$export$b7fea8286a4dbf6a = "spt_id_password_timeout";
const $6a1e4986bef74680$export$e0d09a1a7b4e72ff = 60;
const $6a1e4986bef74680$export$dd8d693d6d107c97 = "ui_locale";
const $6a1e4986bef74680$export$31aa35d496f399b3 = "error";
const $6a1e4986bef74680$export$3228d6a4dffe969e = "user_code";
const $6a1e4986bef74680$export$bdd4ef52fecf6cd1 = "device-user-code";

});

parcelRegister("6yaUa", function(module, exports) {

$parcel$export(module.exports, "currentLocale", function () { return $e9281ad2cae72d1f$export$3f314a4a690d76c7; });
$parcel$export(module.exports, "getHostName", function () { return $e9281ad2cae72d1f$export$7d9294ee35eda83a; });
$parcel$export(module.exports, "setLocale", function () { return $e9281ad2cae72d1f$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "t", function () { return $e9281ad2cae72d1f$export$625550452a3fa3ec; });
$parcel$export(module.exports, "_t", function () { return $e9281ad2cae72d1f$export$e1a0bf30965c1cae; });
$parcel$export(module.exports, "translateHtml", function () { return $e9281ad2cae72d1f$export$1dc9f62469526e09; });
$parcel$export(module.exports, "displayValidationErrors", function () { return $e9281ad2cae72d1f$export$f126e540b5e55b28; });
$parcel$export(module.exports, "clearValidationErrors", function () { return $e9281ad2cae72d1f$export$b7702f01a27b2311; });

var $awuvz = parcelRequire("awuvz");

var $3ayFS = parcelRequire("3ayFS");

var $kwzf0 = parcelRequire("kwzf0");

var $fYd14 = parcelRequire("fYd14");
const $e9281ad2cae72d1f$export$a7357cdd1f0b0168 = {
    defaultLocale: "cs",
    locales: [
        "en",
        "cs"
    ]
};
function $e9281ad2cae72d1f$export$b7c662043e31af59(locale) {
    return $e9281ad2cae72d1f$export$a7357cdd1f0b0168.locales.includes(locale);
}
function $e9281ad2cae72d1f$export$3f314a4a690d76c7() {
    try {
        let locale = $e9281ad2cae72d1f$export$a7357cdd1f0b0168.defaultLocale;
        const queryLocale = new URL(window.location.href).searchParams.get((0, $awuvz.QUERY_PARAM_LOCALE_KEY));
        // Go through all cookies and find the one with the locale key
        document.cookie.split(";")?.find((cookie)=>{
            const [key, value] = cookie?.trim().split("=");
            if (key === (0, $awuvz.LOCALE_COOKIE_KEY) && value) // If the value is a valid locale, set it
            {
                if ($e9281ad2cae72d1f$export$b7c662043e31af59(value)) locale = value;
            }
        });
        if (queryLocale && locale !== queryLocale) locale = queryLocale;
        return locale;
    } catch (err) {
        console.error(`Error: ${err}`);
        return $e9281ad2cae72d1f$export$a7357cdd1f0b0168.defaultLocale;
    }
}
function $e9281ad2cae72d1f$export$7d9294ee35eda83a(hostname) {
    if (hostname === "localhost" || hostname === "0.0.0.0") return hostname;
    else return `.${hostname.split(".").slice(1).join(".")}`;
}
function $e9281ad2cae72d1f$export$c8aadf3621e41efb(locale) {
    if ($e9281ad2cae72d1f$export$b7c662043e31af59(locale)) {
        document.cookie = `${0, $awuvz.LOCALE_COOKIE_KEY}=${locale};path=/;SameSite=Lax;Domain=${$e9281ad2cae72d1f$export$7d9294ee35eda83a(window.location.hostname)};Secure`;
        document.documentElement.lang = locale;
        const url = new URL(window.location.href);
        url.searchParams.set((0, $awuvz.QUERY_PARAM_LOCALE_KEY), locale);
        window.history.pushState({}, "", url);
    }
}
function $e9281ad2cae72d1f$export$625550452a3fa3ec(scope, values) {
    const locale = $e9281ad2cae72d1f$export$3f314a4a690d76c7();
    switch(locale){
        case "cs":
            const translationCs = $e9281ad2cae72d1f$export$bb654e07daaf8c3a((0, $kwzf0.default), scope);
            return $e9281ad2cae72d1f$var$setValuesForT(translationCs ?? scope, values);
        case "en":
            const transactionEn = $e9281ad2cae72d1f$export$bb654e07daaf8c3a((0, $fYd14.default), scope);
            return $e9281ad2cae72d1f$var$setValuesForT(transactionEn ?? scope, values);
        default:
            console.error(`Error: Locale ${locale} is not supported, falling back to ${$e9281ad2cae72d1f$export$a7357cdd1f0b0168.defaultLocale}`);
            return $e9281ad2cae72d1f$export$bb654e07daaf8c3a((0, $kwzf0.default), scope);
    }
}
const $e9281ad2cae72d1f$var$setValuesForT = (translation, values)=>{
    if (values) Object.entries(values).forEach(([key, value])=>{
        translation = translation.replace(`#{${key}}`, String(value));
    });
    return translation;
};
function $e9281ad2cae72d1f$export$e1a0bf30965c1cae(scope) {
    return scope;
}
function $e9281ad2cae72d1f$export$1dc9f62469526e09() {
    const nodes = Array.from(document.querySelectorAll(`[${(0, $awuvz.i18n_PATH_ATTRIBUTE)}]`));
    nodes.forEach((node)=>{
        const i18nValues = node.attributes.getNamedItem((0, $awuvz.i18n_VALUES_ATTRIBUTE))?.value;
        const i18nScope = node.getAttribute((0, $awuvz.i18n_PATH_ATTRIBUTE));
        const i18nTarget = node.attributes.getNamedItem((0, $awuvz.i18n_TARGET_ATTRIBUTE))?.value ?? "innerText";
        if (i18nScope) try {
            let translation = $e9281ad2cae72d1f$export$625550452a3fa3ec(i18nScope, i18nValues ? JSON.parse(i18nValues) : undefined);
            // Replace #{year} with the current year for footer scope path to copyright.
            if (i18nScope === "pages.common.footer.copy") translation = translation.replace("#{year}", String(new Date().getFullYear()));
            node[i18nTarget] = translation;
        } catch (e) {
            console.error(`Error: ${e}`);
        }
    });
    // Set metada for current locale
    (0, $3ayFS.setMetadataForLocale)();
    // Update passed query params
    const anchorLinks = Array.from(document.querySelectorAll("a[href]"));
    anchorLinks.forEach((element)=>{
        const href = element?.href;
        if (href?.includes((0, $awuvz.QUERY_PARAM_LOCALE_KEY))) {
            const newUrl = new URL(href);
            newUrl.searchParams.set((0, $awuvz.QUERY_PARAM_LOCALE_KEY), $e9281ad2cae72d1f$export$3f314a4a690d76c7());
            element.setAttribute("href", newUrl.toString());
        }
    });
    const formsWithActions = Array.from(document.querySelectorAll("form[action]"));
    formsWithActions.forEach((element)=>{
        const href = element?.action;
        if (href?.includes((0, $awuvz.QUERY_PARAM_LOCALE_KEY))) {
            const newUrl = new URL(href, document.location.href);
            newUrl.searchParams.set((0, $awuvz.QUERY_PARAM_LOCALE_KEY), $e9281ad2cae72d1f$export$3f314a4a690d76c7());
            element.setAttribute("action", newUrl.pathname + newUrl.search);
        }
    });
}
function $e9281ad2cae72d1f$export$bb654e07daaf8c3a(obj, path, fallback) {
    let i = 0;
    let len = 0;
    const pathArr = path.split(".");
    for(i = 0, pathArr, len = pathArr.length; i < len; i++){
        if (!obj || typeof obj !== "object") return fallback;
        obj = obj[pathArr[i]];
    }
    if (obj === undefined) return fallback;
    return obj;
}
function $e9281ad2cae72d1f$export$f126e540b5e55b28(form, zodError, onlyForPaths) {
    const errors = zodError.flatten((issue)=>{
        return {
            ...issue,
            rootPath: issue.path[0]
        };
    });
    // console.log(errors);
    // Clear previous errors
    $e9281ad2cae72d1f$export$b7702f01a27b2311(form);
    Object.entries(errors.fieldErrors)// Filter out errors that are not specified in the `onlyForPaths` array
    .filter(([path, _])=>{
        if (!onlyForPaths?.length) return true;
        else return onlyForPaths?.includes(path);
    }).forEach(([path, errors], i)=>{
        // console.log(path, errors);
        errors?.forEach((error, index)=>{
            const describedById = `error-${path}_${i}_:${index}:`;
            const relatedFormItem = form.querySelector(`[name="${path}"]`);
            if (relatedFormItem) {
                relatedFormItem.setAttribute("aria-invalid", "true");
                relatedFormItem.setAttribute("aria-describedby", describedById);
                const formGroup = relatedFormItem.closest("div.form-group");
                if (formGroup) {
                    formGroup.setAttribute("data-invalid", "true");
                    let value = "";
                    if (error.code === "too_small") value = error.minimum;
                    if (error.code === "too_big") value = error.maximum;
                    if (error.code === "custom") value = error.params?.maximum || error.params?.minimum || undefined;
                    const errorNode = document.createElement("span");
                    errorNode.textContent = $e9281ad2cae72d1f$export$625550452a3fa3ec(error.message, {
                        value: value
                    });
                    errorNode.id = describedById;
                    errorNode.setAttribute((0, $awuvz.i18n_PATH_ATTRIBUTE), error.message);
                    if (value) errorNode.setAttribute((0, $awuvz.i18n_VALUES_ATTRIBUTE), JSON.stringify({
                        value: value
                    }));
                    errorNode.className = "field-error";
                    formGroup.appendChild(errorNode);
                }
            }
        });
    });
}
function $e9281ad2cae72d1f$export$b7702f01a27b2311(form) {
    const formGroups = form.querySelectorAll("div.form-group");
    formGroups.forEach((formGroup)=>{
        formGroup.removeAttribute("data-invalid");
        formGroup.removeAttribute("aria-describedby");
        const errorNodes = formGroup.querySelectorAll(".field-error");
        errorNodes.forEach((e)=>e.remove());
    });
}

});
parcelRegister("3ayFS", function(module, exports) {

$parcel$export(module.exports, "setMetadataForLocale", function () { return $6d8bd0a240b57814$export$b38a8041503cd7bd; });

var $6yaUa = parcelRequire("6yaUa");
function $6d8bd0a240b57814$export$b38a8041503cd7bd() {
    const scope = document.documentElement.getAttribute("data-scope");
    let metaTitle = (0, $6yaUa.t)("pages.common.metaTitle");
    let metaDescription = (0, $6yaUa.t)("pages.common.metaDescription");
    if (scope) {
        const scopeMetaTitle = (0, $6yaUa.t)(`pages.${scope}.metaTitle`);
        if (scopeMetaTitle && scopeMetaTitle !== `pages.${scope}.metaTitle`) metaTitle = scopeMetaTitle;
    }
    // Set meta title
    document.title = metaTitle;
    // Set og meta title
    const metaOgTitleTag = document.querySelector('meta[property="og:title"]');
    if (metaOgTitleTag) metaOgTitleTag.setAttribute("content", metaTitle);
    // Set meta description
    const metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (metaDescriptionTag) metaDescriptionTag.setAttribute("content", metaDescription);
    // Set og meta description
    const metaOgDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (metaOgDescriptionTag) metaOgDescriptionTag.setAttribute("content", metaDescription);
}

});

parcelRegister("kwzf0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c577eebc37bdeefb$export$2e2bcd8739ae039; });
var $c577eebc37bdeefb$export$2e2bcd8739ae039 = {
    access_denied: "P\u0159\xedstup byl zam\xedtnut",
    validations: {
        email: 'Zadejte validn\xed e-mail ve form\xe1tu "jan@sparta.cz"',
        emailIsUsed: "Tento e-mail je ji\u017E pou\u017Eit\xfd",
        emailNotRegistered: "Tento e-mail nen\xed registrov\xe1n",
        required: "Toto pole je povinn\xe9",
        emojiNotAllowed: "Emoji nejsou povoleny",
        maxLength: "Maxim\xe1ln\xed po\u010Det znak\u016F je: #{value}",
        minLength: "Minim\xe1ln\xed po\u010Det znak\u016F je: #{value}",
        maxValue: "Maxim\xe1ln\xed hodnota je: #{value}",
        minValue: "Minim\xe1ln\xed hodnota je: #{value}",
        invalidDate: "Zadan\xe9 datum nen\xed platn\xe9",
        invalidPhone: "Zadan\xe9 tel. \u010D\xedslo nen\xed validn\xed",
        minAge: "Registrace nen\xed ur\u010Dena osob\xe1m mlad\u0161\xedm #{value} let",
        passwordsDontMatch: "Hesla se neshoduj\xed",
        passwordRequirements: "Heslo mus\xed obsahovat alespo\u0148 jedno velk\xe9 p\xedsmeno, jedno mal\xe9 p\xedsmeno a jedno \u010D\xedslo",
        userCode: 'Zadejte platn\xfd k\xf3d ve form\xe1tu "XXXX-XXXX"'
    },
    errors: {
        pageNotFound: "Str\xe1nka, kterou se sna\u017E\xedte zobrazit, nejsp\xed\u0161 neexistuje, nebo m\xe1te chybn\xfd odkaz.",
        codeNotValid: "K\xf3d nen\xed validn\xed nebo byl ji\u017E pou\u017Eit.",
        invalidPassword: "Heslo nen\xed validn\xed"
    },
    pages: {
        common: {
            metaTitle: "P\u0159ipojte se | SPARTA iD",
            metaDescription: "SPARTA iD | Va\u0161e digit\xe1ln\xed vstupenka do sv\u011Bta Sparty.",
            goToSpartaId: "POKRA\u010COVAT DO SPARTA iD",
            goToSparta: "P\u0159ej\xedt na Sparta.cz",
            or: "nebo",
            and: "a",
            close: "Zav\u0159\xedt",
            others: "Ostatn\xed",
            notifications: {
                title: "Notifikace",
                errors: {
                    generic: "Je n\xe1m l\xedto, n\u011Bco se pokazilo. Pros\xedm zkuste to znovu pozd\u011Bji."
                }
            },
            alternativeSignIns: "Alternativn\xed zp\u016Fsoby p\u0159ihl\xe1\u0161en\xed",
            mainNavigation: "Hlavn\xed navigace",
            previousStep: "P\u0159edchoz\xed krok",
            selectLanguage: "Vyberte jazyk zobrazen\xed",
            socialNetworks: "Soci\xe1ln\xed s\xedt\u011B",
            spartaProclamations: "Prohl\xe1\u0161en\xed Sparta.cz",
            footer: {
                onlinePaymentTerms: "Podm\xednky online platby",
                terms: "Podm\xednky u\u017Eit\xed",
                privacyPolicy: "Ochrana soukrom\xed",
                businessTerms: "Obchodn\xed podm\xednky",
                termsSpartaId: "Podm\xednky SPARTA iD",
                cookies: "Cookies",
                accessibility: "P\u0159\xedstupnost",
                hint: "Polo\u017Eky ozna\u010Den\xe9 hv\u011Bzdi\u010Dkou jsou povinn\xe9",
                copy: "Copyright \xa9 #{year} AC Sparta Praha. V\u0161echna pr\xe1va vyhrazena."
            },
            showPassword: "Uk\xe1zat heslo",
            hidePassword: "Skr\xfdt heslo",
            termUrls: {
                clientDataUrl: "https://1742741114.rsc.cdn77.org/files/2024/07/04/Informace%20o%20zpracova%CC%81ni%CC%81%20osobni%CC%81ch%20u%CC%81daju%CC%8A%20pro%20marketingove%CC%81%20u%CC%81c%CC%8Cely%20na%20za%CC%81klade%CC%8C%20souhlasu.pdf",
                businessTermsUrl: "https://sparta.cz/cs/paticka/podminky-sparta-id",
                personalDataProcessing: "https://1742741114.rsc.cdn77.org/files/2024/07/04/Informace%20o%20zpracova%CC%81ni%CC%81%20osobni%CC%81ch%20u%CC%81daju%CC%8A%20uz%CC%8Civatelu%CC%8A%20SPARTA%20iD%20a%20navazuji%CC%81ci%CC%81ch%20sluz%CC%8Ceb.pdf"
            }
        },
        verify: {
            metaTitle: "Ov\u011B\u0159en\xed e-mailu | SPARTA iD",
            title: "Ov\u011B\u0159en\xed e-mailu",
            verifiedTitle: "Registrace dokon\u010Dena",
            description: "Registraci \xfa\u010Dtu dokon\u010D\xedte kliknut\xedm na aktiva\u010Dn\xed odkaz, kter\xfd naleznete v emailu: ",
            verifiedDescription: "\xda\u010Det byl \xfasp\u011B\u0161n\u011B aktivov\xe1n",
            alreadyRegistered: "M\xe1te dokon\u010Denou registraci?",
            info: {
                checkFilesAs: "Zkontrolujte slo\u017Eky jako",
                mass: "Hromadn\xe9",
                spam: "Spam"
            },
            form: {
                submit: "Zaslat verifika\u010Dn\xed e-mail",
                sendAgain: "Zaslat znovu"
            },
            notifications: {
                success: {
                    verified: "\xda\u010Det byl \xfasp\u011B\u0161n\u011B aktivov\xe1n",
                    mailSent: "E-mail byl \xfasp\u011B\u0161n\u011B odesl\xe1n"
                }
            }
        },
        activate: {
            metaTitle: "Zajdete k\xf3d | SPARTA iD",
            title: "Pro pokra\u010Dov\xe1n\xed zadejte k\xf3d, kter\xfd vid\xedte na sv\xe9 televizi",
            form: {
                placeholders: {
                    code: "XXXX-XXXX"
                },
                continue: "Pokra\u010Dovat",
                cancel: "Zru\u0161it"
            },
            note: "Pokud p\u0159ihl\xe1\u0161en\xed tohoto za\u0159\xedzen\xed nepozn\xe1v\xe1te, klikn\u011Bte na tla\u010D\xedtko Zru\u0161it. V\xedce se dozv\xedte v na\u0161\xed n\xe1pov\u011Bd\u011B."
        },
        activateConfirm: {
            metaTitle: "Potvrzen\xed aktivace | SPARTA iD",
            title: "Vid\xedte tento k\xf3d ve sv\xe9 televizi?",
            form: {
                continue: "Ano, souhlas\xed",
                cancel: "Ne, nesouhlas\xed"
            }
        },
        activateSuccess: {
            metaTitle: "\xdasp\u011B\u0161n\xe1 aktivace | SPARTA iD",
            title: "Za\u0159\xedzen\xed bylo \xfasp\u011B\u0161n\u011B nastaveno",
            form: {
                cancel: "P\u0159ej\xedt na Sparta.cz"
            }
        },
        authorize: {
            metaTitle: "P\u0159ipojte se | SPARTA iD",
            noSpartId: "Je\u0161t\u011B nem\xe1te SPARTA iD?",
            signUp: "Vytvo\u0159it \xfa\u010Det",
            forgottenPassword: "Zapomenut\xe9 heslo?",
            form: {
                placeholders: {
                    password: "Heslo"
                },
                continue: "Pokra\u010Dovat",
                signIn: "P\u0159ihl\xe1sit se"
            }
        },
        register: {
            metaTitle: "Registrace | SPARTA iD",
            continueThrough: "Pokra\u010Dovat p\u0159es",
            haveSpartId: "U\u017E m\xe1te SPARTA iD?",
            signIn: "P\u0159ihlaste se",
            ageInfo: "Registrac\xed potvrzujete, \u017Ee jste star\u0161\xed 15-ti let. V\xa0p\u0159\xedpad\u011B nepravdiv\xe9ho potvrzen\xed o\xa0dosa\u017Een\xed tohoto v\u011Bkov\xe9ho limitu jsme opr\xe1vn\u011Bni takto registrovan\xfd \xfa\u010Det zru\u0161it.",
            form: {
                placeholders: {
                    firstName: "Jm\xe9no",
                    lastName: "P\u0159\xedjmen\xed",
                    password: "Heslo",
                    passwordAgain: "Heslo znovu",
                    phoneNumber: "Telefonn\xed \u010D\xedslo",
                    phoneNumberPrefix: "P\u0159edvolba",
                    gender: "Pohlav\xed",
                    favouritePlayer: "Obl\xedben\xfd spar\u0165an",
                    day: "Den",
                    month: "M\u011Bs\xedc",
                    year: "Rok"
                },
                gender: {
                    male: "Mu\u017E",
                    female: "\u017Dena"
                },
                marketing: {
                    text: "Chci dost\xe1vat novinky o akc\xedch a speci\xe1ln\xedch nab\xeddk\xe1ch partner\u016F a",
                    terms: "souhlas\xedm se zpracov\xe1n\xedm osobn\xedch \xfadaj\u016F"
                },
                terms: {
                    iAgreeWith: "Souhlas\xedm s",
                    conditions: "obchodn\xedmi podm\xednkami",
                    andAgreeWith: "a beru na v\u011Bdom\xed pou\u010Den\xed o",
                    dataProcessing: "zpracov\xe1n\xed osobn\xedch \xfadaj\u016F"
                },
                saveAndContinue: "Ulo\u017Eit a pokra\u010Dovat",
                finishRegistration: "Dokon\u010Dit registraci"
            }
        },
        password: {
            metaTitle: "Obnova hesla | SPARTA iD",
            title: "Obnova hesla",
            perex: "Obnova p\u0159\xedstupu k \xfa\u010Dtu prob\u011Bhne kliknut\xedm na odkaz, kter\xfd za\u0161leme na zadan\xfd email: ",
            form: {
                placeholders: {
                    newPassword: "Nov\xe9 heslo",
                    newPasswordAgain: "Nov\xe9 heslo znovu"
                },
                submit: "Nastavit nov\xe9 heslo",
                request: "Zaslat ov\u011B\u0159ovac\xed e-mail"
            },
            notifications: {
                success: {
                    mailSent: "E-mail byl \xfasp\u011B\u0161n\u011B odesl\xe1n",
                    passwordChanged: "Heslo bylo \xfasp\u011B\u0161n\u011B zm\u011Bn\u011Bno"
                },
                error: {
                    recovery_code_not_found: "Ov\u011B\u0159ovac\xed k\xf3d nebyl nalezen nebo ji\u017E byl pou\u017Eit"
                }
            },
            rememberPassword: "Vzpomn\u011Bli jste si na heslo?",
            signIn: "P\u0159ihlaste se",
            proceedToSignIn: "P\u0159ej\xedt na p\u0159ihl\xe1\u0161en\xed"
        },
        consent: {
            metaTitle: "P\u0159ipojte se | SPARTA iD",
            title: "P\u0159ihl\xe1\u0161en\xed do slu\u017Eby",
            requires: {
                title: "vy\u017Eaduje pro pokra\u010Dov\xe1n\xed:",
                fullName: "Jm\xe9no a p\u0159\xedjmen\xed",
                email: "Emailov\xe1 adresa",
                photo: "Profilov\xe1 fotka"
            },
            form: {
                continue: "Pokra\u010Dovat",
                cancel: "NESOUHLAS\xcdM, P\u0158EJ\xcdT DO SPARTA iD"
            },
            terms: {
                byContinuing: "Tato slu\u017Eba z\xedsk\xe1 p\u0159\xedstup k v\xe1mi sd\xedlen\xfdm informac\xedm. Pokra\u010Dov\xe1n\xedm souhlas\xedte s ",
                terms: "Obchodn\xedmi podm\xednkami",
                andAcknowledge: "a berete na v\u011Bdom\xed pou\u010Den\xed o ",
                dataProcessing: "Zpracov\xe1n\xed osobn\xedch \xfadaj\u016F"
            }
        },
        notFound: {
            title: "Tuto str\xe1nku jste netrefili",
            message: "Str\xe1nka, kterou se sna\u017E\xedte zobrazit, nejsp\xed\u0161 neexistuje, nebo m\xe1te chybn\xfd odkaz."
        },
        ssoAlreadyUsed: {
            title: "E-mail se ji\u017E pou\u017E\xedv\xe1",
            message: "P\u0159ihl\xe1\u0161en\xed se nezda\u0159ilo, proto\u017Ee \xfa\u010Det s\xa0touto e-mailovou adresou ji\u017E existuje:",
            help: "Propojen\xed \xfa\u010Dt\u016F je mo\u017En\xe9 prov\xe9st pozd\u011Bji v nastaven\xed SPARTA\xa0iD",
            goToSignIn: "P\u0159ej\xedt na p\u0159ihl\xe1\u0161en\xed"
        }
    }
};

});

parcelRegister("fYd14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df54ab9e1b7f6be1$export$2e2bcd8739ae039; });
var $df54ab9e1b7f6be1$export$2e2bcd8739ae039 = {
    access_denied: "Access denied",
    validations: {
        email: "Please enter a valid e-mail address",
        emailIsUsed: "This e-mail address is already in use",
        emailNotRegistered: "This e-mail is not registered",
        required: "This field is required",
        emojiNotAllowed: "Emoji are not allowed",
        maxLength: "Maximum character count is: #{value}",
        minLength: "Minimum character count is: #{value}",
        maxValue: "Maximum value is: #{value}",
        minValue: "Minimum value is: #{value}",
        invalidDate: "Please enter a valid date",
        invalidPhone: "Please enter a valid phone number",
        minAge: "Registration is not available for people younger than #{value} years",
        passwordsDontMatch: "Passwords do not match",
        passwordRequirements: "Password must contain at least one uppercase letter, one lowercase letter and one number",
        userCode: 'Please enter a valid code in the format "XXXX-XXXX"'
    },
    errors: {
        pageNotFound: "The page you are trying to access does not exist or you have a broken link.",
        codeNotValid: "Code is invalid or was already used.",
        invalidPassword: "Invalid credentials"
    },
    pages: {
        common: {
            metaTitle: "Join us | SPARTA iD",
            metaDescription: "SPARTA iD | Your digital ticket to the world of Sparta.",
            goToSpartaId: "CONTINUE TO SPARTA iD",
            goToSparta: "Go to Sparta.cz",
            or: "or",
            and: "and",
            close: "Close",
            others: "Others",
            notifications: {
                title: "Notifications",
                errors: {
                    generic: "We're sorry, something went wrong. Please try again later."
                }
            },
            alternativeSignIns: "Alternative sign in options",
            mainNavigation: "Main navigation",
            previousStep: "Previous step",
            selectLanguage: "Select a language",
            socialNetworks: "Social networks",
            spartaProclamations: "Statements of Sparta.cz",
            footer: {
                onlinePaymentTerms: "Online Payment Terms",
                terms: "Terms of Use",
                privacyPolicy: "Privacy Policy",
                businessTerms: "Business Terms",
                termsSpartaId: "SPARTA iD Terms",
                cookies: "Cookies",
                accessibility: "Accessibility",
                hint: "Items marked with an asterisk are mandatory",
                copy: "Copyright \xa9 #{year} AC Sparta Prague. All rights reserved."
            },
            showPassword: "Show password",
            hidePassword: "Hide password",
            termUrls: {
                clientDataUrl: "https://1742741114.rsc.cdn77.org/files/2024/07/04/Information%20on%20processing%20of%20personal%20data%20for%20marketing%20purposes%20based%20on%20consent.pdf",
                businessTermsUrl: "https://sparta.cz/en/paticka/sparta-id-terms",
                personalDataProcessing: "https://1742741114.rsc.cdn77.org/files/2024/07/04/Information%20on%20personal%20data%20processing%20users%20of%20SPARTA%20iD%20and%20related%20services.pdf"
            }
        },
        verify: {
            metaTitle: "E-mail verification | SPARTA iD",
            metaDescription: "E-mail verification",
            title: "E-mail verification",
            verifiedTitle: "Registration completed",
            description: "Complete the account registration by clicking on the activation link found in the email: ",
            verifiedDescription: "Your account has been successfully activated",
            alreadyRegistered: "Already Signed up?",
            info: {
                checkFilesAs: "Check folders such as",
                mass: "Mass",
                spam: "Spam"
            },
            form: {
                submit: "Send verification e-mail",
                sendAgain: "Send again"
            },
            notifications: {
                success: {
                    verified: "Account was successfully activated",
                    mailSent: "E-mail was sent successfully"
                }
            }
        },
        activate: {
            metaTitle: "Zajdete k\xf3d | SPARTA iD",
            title: "For continuation, enter the code you see on your TV",
            form: {
                placeholders: {
                    code: "XXXX-XXXX"
                },
                continue: "Continue",
                cancel: "Cancel"
            },
            note: "If you do not recognize the login of this device, click the Cancel button. You can find out more in our help section."
        },
        activateConfirm: {
            metaTitle: "Activation Confirmation | SPARTA iD",
            title: "Do you see this code on your TV?",
            form: {
                continue: "Yes, it matches",
                cancel: "No, it doesn't match"
            }
        },
        activateSuccess: {
            metaTitle: "Activation Success | SPARTA iD",
            title: "Device has been successfully activated",
            form: {
                cancel: "Go to Sparta.cz"
            }
        },
        authorize: {
            metaTitle: "Join us | SPARTA iD",
            noSpartId: "No SPARTA iD yet?",
            signUp: "Sign up",
            forgottenPassword: "Forgotten password?",
            form: {
                placeholders: {
                    password: "Password"
                },
                continue: "Continue",
                signIn: "Sign in"
            }
        },
        register: {
            metaTitle: "Register | SPARTA iD",
            continueThrough: "Continue with",
            haveSpartId: "Already have SPARTA iD?",
            signIn: "Sign in",
            ageInfo: "By registering you confirm that you are over 15 years of age. In the event of false confirmation that you have reached this age limit, we are entitled to cancel the registered account.",
            form: {
                placeholders: {
                    firstName: "First name",
                    lastName: "Last name",
                    password: "Password",
                    passwordAgain: "Password again",
                    phoneNumber: "Phone number",
                    phoneNumberPrefix: "Prefix",
                    gender: "Gender",
                    favouritePlayer: "Favorite Sparta player",
                    day: "Day",
                    month: "Month",
                    year: "Year"
                },
                gender: {
                    male: "Male",
                    female: "Female"
                },
                marketing: {
                    text: "I would like to receive updates on promotions and special offers from partners and",
                    terms: "I agree to the processing of personal data"
                },
                terms: {
                    iAgreeWith: "I agree with",
                    conditions: "terms and conditions",
                    andAgreeWith: "and acknowledge the information on the",
                    dataProcessing: "processing of personal data"
                },
                saveAndContinue: "Save and continue",
                finishRegistration: "Finish registration"
            }
        },
        password: {
            metaTitle: "Forgotten password | SPARTA iD",
            title: "Forgotten password",
            perex: "To recover access to your account, click on the link we will send to the specified email: ",
            form: {
                placeholders: {
                    newPassword: "New password",
                    newPasswordAgain: "New password again"
                },
                submit: "Change password",
                request: "Send verification e-mail"
            },
            rememberPassword: "Remembered your password?",
            signIn: "Sign in",
            notifications: {
                success: {
                    mailSent: "E-mail was sent successfully",
                    passwordChanged: "Password was successfully changed"
                },
                error: {
                    recovery_code_not_found: "Recovery code not found or already used"
                }
            },
            proceedToSignIn: "Proceed to Sign in"
        },
        consent: {
            metaTitle: "Join us | SPARTA iD",
            title: "Sign in to service",
            requires: {
                title: "requires following data to continue:",
                fullName: "Full name",
                email: "E-mail address",
                photo: "Profile photo"
            },
            form: {
                continue: "Continue",
                cancel: "I DISAGREE, GO TO SPARTA iD"
            },
            terms: {
                byContinuing: "This service gets access to the information you share. By continuing you agree to ",
                terms: "Terms and Conditions",
                andAcknowledge: "and you acknowledge the instructions on ",
                dataProcessing: "Processing of personal data"
            }
        },
        notFound: {
            title: "This page was a miss",
            message: "The page you're trying to view probably doesn't exist, or you have the wrong link."
        },
        ssoAlreadyUsed: {
            title: "E-mail already in use",
            message: "Sign in failed because an account with this\xa0email address already exists:",
            help: "Linking accounts can be done later in SPARTA\xa0iD settings",
            goToSignIn: "Go to Sign in"
        }
    }
};

});


parcelRegister("fa6hB", function(module, exports) {
$parcel$export(module.exports, "getI18nMonths", function () { return (parcelRequire("lw2DV")).getI18nMonths; });
$parcel$export(module.exports, "goToFormStep", function () { return (parcelRequire("lw2DV")).goToFormStep; });
$parcel$export(module.exports, "handleFetchResponse", function () { return (parcelRequire("lw2DV")).handleFetchResponse; });
$parcel$export(module.exports, "inputLanguageFromLocale", function () { return (parcelRequire("lw2DV")).inputLanguageFromLocale; });
$parcel$export(module.exports, "isValidSelectDate", function () { return (parcelRequire("lw2DV")).isValidSelectDate; });
$parcel$export(module.exports, "matchesMinAge", function () { return (parcelRequire("lw2DV")).matchesMinAge; });
$parcel$export(module.exports, "parseDefaultValue", function () { return (parcelRequire("lw2DV")).parseDefaultValue; });
$parcel$export(module.exports, "setLoadingState", function () { return (parcelRequire("lw2DV")).setLoadingState; });
$parcel$export(module.exports, "simpleIsoDateFromSelect", function () { return (parcelRequire("lw2DV")).simpleIsoDateFromSelect; });
$parcel$export(module.exports, "simulateFormAction", function () { return (parcelRequire("lw2DV")).simulateFormAction; });
$parcel$export(module.exports, "Notifications", function () { return (parcelRequire("ZjXzN")).Notifications; });
parcelRequire("lw2DV");
parcelRequire("ZjXzN");
parcelRequire("3ayFS");

});
parcelRegister("lw2DV", function(module, exports) {

$parcel$export(module.exports, "setLoadingState", function () { return $2b1b48a5948b6647$export$c632ebbfa9ca90ce; });
$parcel$export(module.exports, "getI18nMonths", function () { return $2b1b48a5948b6647$export$800a159e55bdfdbe; });
$parcel$export(module.exports, "isValidSelectDate", function () { return $2b1b48a5948b6647$export$705a0b46e202fd73; });
$parcel$export(module.exports, "simpleIsoDateFromSelect", function () { return $2b1b48a5948b6647$export$894007db0cd3af5f; });
$parcel$export(module.exports, "matchesMinAge", function () { return $2b1b48a5948b6647$export$d675b50bd046808a; });
$parcel$export(module.exports, "parseDefaultValue", function () { return $2b1b48a5948b6647$export$8679495f46a9e5ce; });
$parcel$export(module.exports, "goToFormStep", function () { return $2b1b48a5948b6647$export$babc0afa7391e07e; });
$parcel$export(module.exports, "handleFetchResponse", function () { return $2b1b48a5948b6647$export$217f7ea4550ad19d; });
$parcel$export(module.exports, "simulateFormAction", function () { return $2b1b48a5948b6647$export$faf85deb167ec45f; });
$parcel$export(module.exports, "inputLanguageFromLocale", function () { return $2b1b48a5948b6647$export$28f5f044510c8a5a; });

var $6yaUa = parcelRequire("6yaUa");
const $2b1b48a5948b6647$export$e772c8ff12451969 = (ms = 500)=>new Promise((r)=>setTimeout(r, ms));
function $2b1b48a5948b6647$export$c632ebbfa9ca90ce(form, isLoading) {
    const submitButtons = form.querySelectorAll('button[type="submit"]');
    submitButtons.forEach((sb)=>sb?.setAttribute("data-loading", String(isLoading)));
}
function $2b1b48a5948b6647$export$800a159e55bdfdbe(format = "long") {
    const locale = (0, $6yaUa.currentLocale)();
    const formatter = new Intl.DateTimeFormat(locale, {
        month: format,
        timeZone: "UTC"
    });
    const months = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ].map((month)=>{
        const mm = month < 10 ? `0${month}` : month;
        return new Date(`1991-${mm}-01T00:00:00+00:00`);
    });
    return months.map((date, i)=>({
            monthIndex: i,
            label: formatter.format(date)
        }));
}
function $2b1b48a5948b6647$export$c03bb0116ee09d4b(date) {
    return !isNaN(new Date(date));
}
function $2b1b48a5948b6647$export$705a0b46e202fd73(day, month, year) {
    const dateStr = `${month}/${day}/${year}`;
    const date = new Date(dateStr);
    return $2b1b48a5948b6647$export$c03bb0116ee09d4b(date) && date.getMonth() + 1 === Number(month);
}
function $2b1b48a5948b6647$var$stringifyDayMonth(value) {
    const numberValue = Number(value);
    if (!value) return "";
    if (numberValue < 10) return `0${numberValue}`;
    return value;
}
function $2b1b48a5948b6647$export$894007db0cd3af5f(day, month, year) {
    const dateString = `${year}-${$2b1b48a5948b6647$var$stringifyDayMonth(month)}-${$2b1b48a5948b6647$var$stringifyDayMonth(day)}`;
    return dateString;
}
function $2b1b48a5948b6647$export$8006d3d90cdafd7a(day, month, year) {
    const dateStr = `${month}/${day}/${year}`;
    const date = new Date(dateStr);
    const currentDate = new Date();
    const differenceInYears = currentDate.getFullYear() - date.getFullYear();
    return differenceInYears;
}
function $2b1b48a5948b6647$export$d675b50bd046808a(day, month, year, requiredAge) {
    const age = $2b1b48a5948b6647$export$f88bca358e36d143(day, month, year);
    return age >= requiredAge;
}
function $2b1b48a5948b6647$export$f88bca358e36d143(day, month, year, forceToday) {
    const birthDate = new Date(`${year}-${$2b1b48a5948b6647$var$stringifyDayMonth(month)}-${$2b1b48a5948b6647$var$stringifyDayMonth(day)}`);
    const today = forceToday ?? new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) age--;
    return age;
}
function $2b1b48a5948b6647$export$8679495f46a9e5ce(value) {
    if (value?.startsWith("{{")) return null;
    return value;
}
function $2b1b48a5948b6647$export$babc0afa7391e07e(form, activateStep = 2, focusQuerySelector) {
    Array.from(form.querySelectorAll("[data-step]")).forEach((div)=>{
        if (div.getAttribute("data-step") === String(activateStep)) div.classList.add("active");
        else div.classList.remove("active");
    });
    if (focusQuerySelector) {
        const focusElement = form.querySelector(focusQuerySelector);
        if (focusElement) focusElement?.focus?.();
    }
}
async function $2b1b48a5948b6647$export$217f7ea4550ad19d(response) {
    if (!response.ok) {
        if (response.headers?.get("content-type")?.includes("application/json")) {
            const errorOut = await response.json();
            throw errorOut;
        }
        const errorDetails = await response.text();
        throw new Error(`Fetch error: ${response.status} ${response.statusText}. Details: ${errorDetails}`);
    }
    return response;
}
function $2b1b48a5948b6647$export$faf85deb167ec45f(formData, formRef) {
    const privateForm = document.createElement("form");
    privateForm.action = formRef.action;
    privateForm.method = formRef.method;
    privateForm.style.display = "none";
    if (formData) {
        const data = Object.fromEntries(formData);
        Object.entries(data).forEach(([key, value])=>{
            const input = document.createElement("input");
            input.name = key;
            input.value = value.toString();
            privateForm.appendChild(input);
        });
        formRef.append(privateForm);
    }
    privateForm.submit();
}
function $2b1b48a5948b6647$export$28f5f044510c8a5a(locale) {
    switch(locale){
        case "cs":
            return "czech";
        case "en":
            return "english";
        default:
            return "czech";
    }
}

});

parcelRegister("ZjXzN", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return $b4412bdff8284112$export$36ba2f559d49a8f6; });

var $7i3fq = parcelRequire("7i3fq");

var $6yaUa = parcelRequire("6yaUa");
class $b4412bdff8284112$export$36ba2f559d49a8f6 {
    static create(title, timeout = 4000) {
        const toastRegion = document.querySelector(".toast-region");
        if (!toastRegion) {
            console.warn("Toast region not found. Could not create toast.");
            return;
        }
        const uid = crypto.randomUUID();
        const toast = document.createElement("div");
        toast.innerHTML = `
      <div class="toast" role="alert" aria-labelledby="${uid}">
        <span id="${uid}" data-i18n="${title}">${(0, $6yaUa.t)(title)}</span>
        <button type="button" aria-label="Zav\u{159}\xedt" data-i18n="pages.common.close" i18n-target="ariaLabel" class="close">x</button>
      </div>
    `;
        const closeButton = toast.querySelector(".close");
        if (closeButton) closeButton.addEventListener("click", ()=>{
            toastRegion.removeChild(toast);
        });
        toastRegion.appendChild(toast);
        if (timeout !== "infinite") setTimeout(()=>{
            if (toastRegion.contains(toast)) toastRegion.removeChild(toast);
        }, timeout);
    }
    static createErrorToast(error, context = "Submit error:") {
        console.error(context, error);
        (0, $7i3fq.isErrorOut)(error);
        $b4412bdff8284112$export$36ba2f559d49a8f6.create("pages.common.notifications.errors.generic");
    }
}

});
parcelRegister("7i3fq", function(module, exports) {

$parcel$export(module.exports, "isErrorOut", function () { return $752307d0370b095f$export$f4744a551dd010e2; });
function $752307d0370b095f$export$f4744a551dd010e2(response) {
    return response?.error !== undefined && response?.cause !== undefined;
}

});





parcelRequire("jOfgJ");
})();
//# sourceMappingURL=activate-success.9a67130a.js.map
